import {
    amendHpPostBodyFromData,
    createHpDeviceDraftPostBody,
    createHpPostBodyFromData,
} from "./hpSpec"
import {
    TAmendEbDevicePostBody,
    TPublishEbDevicePostBody,
    TSaveEbDeviceDraftPostBody,
} from "../../../../services/middleware/types/devices/lct/publishEbDeviceTypes"
import { HpDeviceFormData } from "../types/providerTypes"

export const EB_FUNCTIONS = ["N/A"]
export const EB_TYPES = ["Electric Boiler"]

/**
 * Generates create EB post body from form data.
 * Mirrors the HP post body exactly, overriding only device_type.
 * @param {HpDeviceFormData} formData - data input from the form
 * @param {string} attachmentUUID - device attachment UUID
 * @returns {TPublishEbDevicePostBody} - the post body for the publish LCT device request
 */
export const createEbPostBodyFromData = (
    formData: HpDeviceFormData,
    attachmentUUID: string,
    systemReference?: string
): TPublishEbDevicePostBody => {
    const hpBody = createHpPostBodyFromData(
        formData,
        attachmentUUID,
        systemReference
    )
    return {
        ...hpBody,
        device_type: "EB",
        device_data: {
            ...hpBody.device_data,
            LCTDeviceType: "EB",
        },
    }
}

/**
 * Generates the save-draft EB post body from form data.
 * Mirrors the HP draft post body exactly, overriding only device_type.
 * @param {HpDeviceFormData} formData - data input from the form
 * @param {string} attachmentUUID - device attachment UUID
 * @param {boolean} isAmendment - whether the draft is for an amendment
 * @returns {TSaveEbDeviceDraftPostBody} - the post body for the save draft request
 */
export const createEbDeviceDraftPostBody = (
    formData: HpDeviceFormData,
    attachmentUUID: string,
    isAmendment: boolean,
    systemReference?: string
): TSaveEbDeviceDraftPostBody => {
    const hpBody = createHpDeviceDraftPostBody(
        formData,
        attachmentUUID,
        isAmendment,
        systemReference
    )
    return {
        ...hpBody,
        device_type: "EB",
        device_data: {
            ...hpBody.device_data,
            LCTDeviceType: "EB",
        },
    }
}

/**
 * Generates the amend EB post body from form data.
 * Mirrors the HP amend post body exactly, overriding only device_type.
 * @param {HpDeviceFormData} formData - data input from the form
 * @param {string} attachmentUUID - device attachment UUID
 * @param {string} systemReference - the device system reference
 * @returns {TAmendEbDevicePostBody} - the post body for the amend LCT device request
 */
export const amendEbPostBodyFromData = (
    formData: HpDeviceFormData,
    attachmentUUID: string,
    systemReference: string
): TAmendEbDevicePostBody => {
    const hpBody = amendHpPostBodyFromData(
        formData,
        attachmentUUID,
        systemReference
    )
    return {
        ...hpBody,
        device_type: "EB",
        device_data: {
            ...hpBody.device_data,
            LCTDeviceType: "EB",
        },
    }
}
